import React, { FC } from 'react';
import { Trans } from '@lingui/macro';
import { CrewMember, RodRequestCrewMemberStats } from '@bechtel/types';
import { Text, Box, Avatar, AvatarSize, theme } from '@bechtel/gds';
import { useName } from '@bechtel/client-common';
import { ContainerStyled } from './styled';
import { StencilStats } from '../types';

interface StencilCloseRequestStatusProps {
  rodRequestCrewMemberStatsItem: RodRequestCrewMemberStats;
  onViewStencilId: (stencild: CrewMember['id']) => void;
  welderStatsCount: StencilStats | undefined;
  stencilId: CrewMember['id'];
  index: string;
}

export const StencilCloseRequestStatus: FC<StencilCloseRequestStatusProps> = ({
  rodRequestCrewMemberStatsItem,
  onViewStencilId,
  welderStatsCount,
  stencilId,
  index,
}) => {
  const { getFullName } = useName();

  const { crewMember = null } = rodRequestCrewMemberStatsItem ? rodRequestCrewMemberStatsItem : {};
  return (
    <ContainerStyled data-testid={`stencil-item-${index}`} isSelected={crewMember?.id === stencilId}>
      <Box
        css={{ borderBottom: `1px solid ${theme.colors.grey[300]}` }}
        py={{ sm: '450' }}
        mx={{ sm: '450' }}
        justifyContent={{ sm: 'space-between' }}
        onClick={(e) => {
          e.preventDefault();
          crewMember && onViewStencilId(crewMember?.id);
        }}
      >
        <Box alignItems={{ sm: 'center' }} data-testid={`stencil-detail-${index}`}>
          <Box pr={{ sm: '450' }}>
            <Avatar src={crewMember && crewMember?.imageUrl} size={AvatarSize.MEDIUM} />
          </Box>
          <Box flexDirection={{ sm: 'column' }}>
            <Text size="500" color="grey.600">
              {getFullName(crewMember?.firstName, crewMember?.lastName)}
            </Text>
            <Box pt={{ sm: '100' }}>
              <Text size="300" color="grey.600" style={{ opacity: 0.6 }}>
                ({crewMember?.badgeNumber})
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          flexDirection={{ sm: 'column' }}
          mr={{ sm: '200' }}
          alignSelf={{ sm: 'flex-end' }}
          data-testid={`stencil-request-detail-${index}`}
        >
          <Box alignSelf={{ sm: 'end' }}>
            {welderStatsCount && crewMember && welderStatsCount[crewMember?.id] && (
              <Text weight="600" size="400" color="grey.1000">
                ( {welderStatsCount[crewMember?.id]?.closed}/{welderStatsCount[crewMember?.id]?.open} )
              </Text>
            )}
          </Box>
          <Box mt={{ sm: '100' }}>
            <Text size="300" color="grey.600" style={{ opacity: 0.6 }}>
              <Trans>Closed</Trans>
            </Text>
          </Box>
        </Box>
      </Box>
    </ContainerStyled>
  );
};
